<button
  class="primary-btn quick-order-btn"
  [routerLink]="{ cxRoute: 'quickOrder' } | cxUrl"
  [class.disabled]="showSrp"
  [disabled]="showSrp"
  [ngClass]="activeLanguage$ | async"
>
  {{ 'cart.cartAction.quickOrder' | cxTranslate }}
</button>
